"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reduce = reduce;
function reduce(state = 0) {
    return state + 1;
}

//# sourceMappingURL=stateId.js.map